var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agb-view footer-margin do-not-translate"},[(_vm.terms!==null)?_c('div',{staticClass:"container footer-margin",domProps:{"innerHTML":_vm._s(_vm.terms)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }